
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressGICsFR]",
      function () {
        return require("private-next-pages/[...wordpressGICsFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressGICsFR]"])
      });
    }
  